<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Banka</label>
            <v-select-list :options="banks" v-model="bank" placeholder="Banka" label="Name"></v-select-list>
        </div>
        <div class="col-12 mt-1">
            <label class="form-label">Taksit</label>
            <input class="form-control" v-mask="'##'" v-model="value.Installment" placeholder="Taksit"/>
        </div>
        <div class="col-12 mt-1">
            <b-form-checkbox v-model="value.IsForSunProduct">Güneş Ürünü Taksidi</b-form-checkbox>
        </div>
        <div class="col-12 mt-1">
            <b-form-checkbox v-model="value.IsCommissionApplied">Komisyon Var Mı</b-form-checkbox>
        </div>
        <div class="col-12 mt-1" v-if="value.IsCommissionApplied">
            <label class="form-label">Komisyon (%)</label>
            <input class="form-control" type="number" v-model="value.CommissionRate" placeholder="Komisyon (%)"/>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object,
        banks:Array
    },
    computed:{
        bank:{
            get:function(){
                return this.banks.find(r=>r.Value == this.value.Bank)
            },
            set:function(value){
                this.value.Bank = value?.Value != "undefined" ? value.Value : null
            }
        },
    }
}
</script>

<style>

</style>